// src/pages/approval/Docs_view.jsx
import React from "react";
import { useParams } from "react-router-dom";
import FormViewManager from "../../components/common/form/FormViewManager";

export default function Docs_view() {
  const { id: projectId, dns } = useParams();

  return (
    <FormViewManager
      params={{
        project: projectId,
        dns,
        module: "approval",
        doc_type: "APP", // 임의코드 (approval 문서용)
      }}
      doc_name="결재 문서 상세"
    >
      {/* 🧾 문서 본문 (children으로 들어감) */}
      <ApprovalDocBody />
    </FormViewManager>
  );
}

/* ✅ 결재문서 본문 내용 렌더링 (FormViewManager에서 meta 주입됨) */
function ApprovalDocBody({ meta, data }) {
  const content = meta?.content || data?.content || "";
  const docType = data?.doc_type || "-";
  const title = data?.title || "-";

  return (
    <div className=" space-y-4 text-sm text-gray-700">
      {/* 기본 정보 */}
      <div className="border-b pb-2">
        <p className="text-base font-semibold">{title}</p>
        <p className="text-xs text-gray-500">문서 유형: {docType}</p>
      </div>

      {/* 본문 */}
      <div
        className="prose prose-sm max-w-none"
        dangerouslySetInnerHTML={{ __html: content }}
      />

      {/* 내용 없을 때 */}
      {!content && (
        <p className="text-xs text-gray-400 text-center">(내용 없음)</p>
      )}
    </div>
  );
}
